import { render, staticRenderFns } from "./SaleInvoiceList.vue?vue&type=template&id=96b05dd2&"
import script from "./SaleInvoiceList.vue?vue&type=script&lang=js&"
export * from "./SaleInvoiceList.vue?vue&type=script&lang=js&"
import style0 from "./SaleInvoiceList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports